import React, { useState, useEffect } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import CompletedComponent from './CompletedComponent';

import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
// import InformationForm from "./InformationForm";
// import PositionForm from "./PositionForm";
// import DocumentForm from "./DocumentForm";
import DefaultForm from "./form/defaultForm";
import CarInfoForm from "./form/FormCustomerInfo";
import AllRoundPhotoForm from "./form/FormAllRoundPhoto";
import AccessoryForm from "./form/FormAccessory";
import DocumentForm from "./form/FormDocument";
import DamagedPartForm from "./form/FormDamagedPart";
import InspectionResultForm from "./form/FormInspectionResult";

import { GetInspectionCase, SaveInspection, SaveImage } from './API'; // , SaveImageAddOn
import { GetCaseStep, SaveCaseStep } from './API';
import CircularProgress from '@mui/material/CircularProgress';



// console.log(window.location)
const windowUrl = window.location.search;
// console.log(windowUrl)
const params = new URLSearchParams(windowUrl);
// console.log(params)

// const ref_no = params.get('_r')
// console.log(ref_no) // BOD202209-12603

const encodedrNO = params.get('_r')
// console.log(encodedrNO) // Qk9EMjAyMjA5LTEyNjAz
  // // Decode the String
  var ref_no = atob(encodedrNO);
  // console.log(ref_no); // Outputs: ABB202209-13007

const encodedcID = params.get('_c')
// console.log(encodedcID) // Qk9EMjAyMjA5LTEyNjAz
  // // Decode the String
  var caseID = atob(encodedcID);
  // console.log(caseID); // Outputs: 138


const steps = ["ข้อมูลรถ", "รูปถ่ายรอบคัน", "อุปกรณ์ตกแต่ง", "เอกสาร", "ความเสียหาย", "ผลการตรวจ"];
const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;
let loadingSize = 40;
    if(windowWidth > windowHeight){ 
        loadingSize = windowHeight*0.75; 
    } else{ 
        loadingSize = windowWidth*0.75; 
    }

function RegisterComponent() {
    const [completed, setCompleted] = useState(false);

    const [firstname, setFirstname] = React.useState("");
    const [lastname, setLastname] = React.useState("");
    const [gender, setGender] = React.useState("");

    const [initalData, setInitalData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [btnLoading, setBtnLoading] = React.useState(false);
    // const [loadingSize, setLoadingSize] = React.useState(40);

    const [activeStep, setActiveStep] = React.useState(1);
    const [dataStep1, setDataStep1] = React.useState("");
    const [dataStep2, setDataStep2] = React.useState("");
    const [dataStep3, setDataStep3] = React.useState("");
    const [dataStep4, setDataStep4] = React.useState("");
    const [dataStep5, setDataStep5] = React.useState("");
    const [dataStep6, setDataStep6] = React.useState("");

    const [byPassData, setByPassData] = React.useState([]);

    // const handleNext = () => {
    //     setActiveStep(activeStep + 1);
    // };

    const handleNext = async (data) => {
        // console.log("caseID", caseID);
        console.log("handleNext step",activeStep, data);
        try {
            // เตรียม sendData สำหรับ Save Data หลัก (ตาม activeStep)
            let sendData = new FormData();
            let skipSaveStep = false;

            if(activeStep == 1){    // save แต่ data ยังไม่ save รูป
                sendData.append('caseID', caseID);
                sendData.append('plate_no', data.plate_no);
                // sendData.append('ref_no', data.ref_no);
                sendData.append('customer_name', data.customer_name);
                sendData.append('car_brand', data.car_brand);
                sendData.append('car_model', data.car_model);
                // sendData.append('mileage', data.mileage); 
            }else if(activeStep == 2){  // ยังไม่ save รูป
                skipSaveStep = true;
                // ⭐️ ใน Step 2, มีแต่การ Save Image เท่านั้น เราจะย้าย logic Save Image ไปไว้ด้านล่าง
            }else if(activeStep == 3){
                ////////////////////////////////////////////////////////////////////////////
                // ... (เตรียม sendData สำหรับ Save Data หลัก Step 3)
                sendData.append('caseID', caseID);

                sendData.append("accessory[spareTire][obj_id_SpareTire]", byPassData.obj_id_SpareTire);
                sendData.append("accessory[spareTire][partname]", "ยางอะไหล่");
                sendData.append("accessory[spareTire][part_detail]", "ยางอะไหล่");
                sendData.append("accessory[spareTire][available]", data.imagesSpareTire && data.imagesSpareTire.length > 0 ? 1 : 0);

                sendData.append("accessory[carCAM][obj_id_CarCAM]", byPassData.obj_id_CarCAM);
                sendData.append("accessory[carCAM][partname]", "กล้องหน้ารถยนต์");
                sendData.append("accessory[carCAM][part_detail]", "กล้องหน้ารถยนต์");
                sendData.append("accessory[carCAM][available]", data.imagesCarCAM && data.imagesCarCAM.length > 0 ? 1 : 0);
               
                // กรณีที่ accessoryData ยังไม่มี data ของ 'ล้อแม็ก' จะต้องค่า default
                sendData.append("accessory[maxWheel][obj_id_MaxWheel]", byPassData.obj_id_MaxWheel?byPassData.obj_id_MaxWheel:0);
                sendData.append("accessory[maxWheel][partname]", "ล้อแม็ก");
                sendData.append("accessory[maxWheel][part_detail]", "ล้อแม็ก");
                // sendData.append("accessory[maxWheel][available]", data.imagesMaxWheel && data.imagesMaxWheel.length > 0 ? 1 : 0);
                // console.log("data.has_maxWheel",data.has_maxWheel);
                sendData.append("accessory[maxWheel][available]", data.has_maxWheel ? data.has_maxWheel : 0); // ถ้าไม่เลือก ให้ถือว่าเป็น ไม่มี

                    data?.capturedImages.forEach((value, index) => {
                        // console.log(`capturedImages3[${index}]`, value);
                        var url = value;
                        if(isValidUrl(url)){
                            console.log("add on tab3 index", index, " is url"); 
                            // console.log("value", value);
                            var chkValue = value.split('?')[0];
                            sendData.append("accessory[other_image]["+index+"]", chkValue);
                            // sendData.append("accessory[other_text]["+index+"]", data.capturedTextImages[index]);
                        }else{ 
                            console.log("add on tab3 index", index, " is not url"); 
                            sendData.append("accessory[other_image]["+index+"]", value);
                        }
                        
                        // sendData.append("accessory[other_image]["+index+"]", value);
                        sendData.append("accessory[other_text]["+index+"]", data.capturedTextImages[index]);
                    });
                ////////////////////////////////////////////////////////////////////////////

            }else if(activeStep == 4){
                // ... (เตรียม sendData สำหรับ Save Data หลัก Step 4)
                ////////////////////////////////////////////////////////////////////////////
                sendData.append('caseID', caseID);

                sendData.append("document[carBook][obj_id_CarBook]", byPassData.obj_id_CarBook);
                sendData.append("document[carBook][partname]", "เล่มทะเบียนรถ");
                sendData.append("document[carBook][part_detail]", "เล่มทะเบียนรถ");
                sendData.append("document[carBook][available]", data.imagesCarBook && data.imagesCarBook.length > 0 ? 1 : 0);

                sendData.append("document[carChassis][obj_id_CarChassis]", byPassData.obj_id_CarChassis);
                sendData.append("document[carChassis][partname]", "เลขตัวถัง");
                sendData.append("document[carChassis][part_detail]", "เลขตัวถัง");
                sendData.append("document[carChassis][available]", data.imagesCarChassis && data.imagesCarChassis.length > 0 ? 1 : 0);

                // ⭐️ ลบการวนลูป data?.capturedImages.forEach(...) ที่อยู่ตรงนี้ออก

                    data?.capturedImages.forEach((value, index) => {
                        // console.log(`capturedImages4[${index}]`, value);
                        var url = value;
                        if(isValidUrl(url)){
                            console.log("add on tab4 index", index, " is url"); 
                            // console.log("value", value);
                            var chkValue = value.split('?')[0];
                            sendData.append("document[other_image]["+index+"]", chkValue);
                            // sendData.append("document[other_text]["+index+"]", data.capturedTextImages[index]);
                        }else{ 
                            console.log("add on tab4 index", index, " is not url"); 
                            sendData.append("document[other_image]["+index+"]", value);
                        }
                        
                        // sendData.append("document[other_image]["+index+"]", value);
                        sendData.append("document[other_text]["+index+"]", data.capturedTextImages[index]);
                    });
                ////////////////////////////////////////////////////////////////////////////
            }else if(activeStep == 5){
                sendData.append('caseID', caseID);
                sendData.append('damage_detail', data.damage_detail);
            }else{
                console.log("activeStep else", activeStep);
            }
            
            let responseData = null;

            // 1. SAVE DATA หลัก (ถ้าไม่ใช่ activeStep == 2)
            if(!skipSaveStep){
                console.log("SaveCaseStep", activeStep);
                // ⭐️ ใช้ await เพื่อรอการ Save Data หลักให้เสร็จ
                const response = await SaveCaseStep(sendData, activeStep);

                if (response && response.status === 200) {
                    responseData = response.data;
                } else if (response && response.data) {
                    console.log("API response error [" + response.status + "]", response.data.message);
                    // setBtnLoading(false);
                    return; // หยุดทำงานหาก Save Data หลักล้มเหลว
                } else {
                    console.log("API response error", response);
                    // setBtnLoading(false);
                    return; // หยุดทำงานหาก Save Data หลักล้มเหลว
                }

                // 2. SAVE IMAGE ตามลำดับ (Sequential)
                console.log("Start saving images sequentially...");

                if(activeStep == 1){ // step1 ยังไม่ save รูปในตอนกด next 
                    // var url_tab1 = data.capturedImages[0];
                    // console.log(isValidUrl(url_tab1));
                    // if(!isValidUrl(url_tab1)){
                    //     const imageFormData = new FormData();
                    //     sendData.append('image', url_tab1);
                    //     sendData.append('caseID', caseID);
                    //     sendData.append('img_type', "MILE");
                    //     console.log("saveImageAPI");
                    //     // ⭐️ ใช้ await เพื่อรอการ Save Image ให้เสร็จ
                    //     await saveImageAPI(imageFormData);
                    // }else{ console.log("url_tab1 is url"); }
                } else if (activeStep == 2) {
                    // ⭐️ ใช้ for...of loop เพื่อบังคับให้ API ทำงานทีละรายการ
                    if (data.capturedImages && data.capturedImages != "undefined") {
                        const imagesToSave = data.capturedImages;
                        const imageTypes = ["VEH_FRONT_LEFT", "VEH_FRONT", "VEH_FRONT_RIGHT", "VEH_BACK_LEFT", "VEH_BACK", "VEH_BACK_RIGHT", "VEH_ENGINE", "VEH_FRONT_CONSOLE"];
                        
                        for (let index = 0; index < imagesToSave.length; index++) {
                            const value = imagesToSave[index];
                            const url = value;
                            if (value && !isValidUrl(url)) {
                                const imageFormData = new FormData();
                                imageFormData.append('image', value);
                                imageFormData.append('caseID', caseID);
                                
                                const img_type = imageTypes[index] || "VEH_OTHER";
                                imageFormData.append('img_type', img_type);
                                imageFormData.append('name', img_type);
                                
                                // ⭐️ ใช้ await เพื่อรอการ Save Image ให้เสร็จ ก่อนไป Index ถัดไป
                                await saveImageAPI(imageFormData, activeStep, index);
                            } else if(value) {
                                 console.log(`tab2 index ${index} is url`);
                            }
                        }
                    }
                }else if(activeStep == 3){
                            // console.log("dataStep3",dataStep3); // ค่าเก็บไว้ส่งต่อ
                            // console.log("data",data);   // ค่าที่ได้ตอน submit
                            // console.log("responseData",responseData);   // ค่าที่ตอบกลับจาก api
                    // 2.1 บันทึก 'ยางอะไหล่'
                    if (data?.imagesSpareTire && !isValidUrl(data.imagesSpareTire[0])) {
                        console.log("imagesSpareTire", "spareTire_objID:", responseData.spareTire_objID);
                        const imageFormData = new FormData();
                        imageFormData.append('image', [data.imagesSpareTire[0]]);
                        imageFormData.append('caseID', caseID);
                        imageFormData.append('img_type', "ACCESSORY");
                        // const obj_id_SpareTire = byPassData.obj_id_SpareTire || 'NEW';
                        const obj_id_SpareTire = byPassData.obj_id_SpareTire || responseData.spareTire_objID;
                        imageFormData.append('obj_id', obj_id_SpareTire);
                        imageFormData.append('new_name', 'ยางอะไหล่');
                        
                        console.log("saveImageAPI");
                        await saveImageAPI(imageFormData); // ⭐️ await
                    }

                    // 2.2 บันทึก 'CarCAM'
                    if (data?.imagesCarCAM && !isValidUrl(data.imagesCarCAM[0])) {
                        console.log("imagesCarCAM", "carCAM_objID:", responseData.carCAM_objID);
                        const imageFormData = new FormData();
                        imageFormData.append('image', [data.imagesCarCAM[0]]);
                        imageFormData.append('caseID', caseID);
                        imageFormData.append('img_type', "ACCESSORY");
                        // const obj_id_CarCAM = byPassData.obj_id_CarCAM || 'NEW';
                        const obj_id_CarCAM = byPassData.obj_id_CarCAM || responseData.carCAM_objID;
                        imageFormData.append('obj_id', obj_id_CarCAM);
                        imageFormData.append('new_name', 'กล้องหน้ารถยนต์');
                        
                        console.log("saveImageAPI");
                        await saveImageAPI(imageFormData); // ⭐️ await
                    }

                    // 2.3 บันทึกรูปภาพ Add On (Loop)
                    if (data?.capturedImages && data.capturedImages.length > 0) {
                         // ⭐️ ใช้ for...of loop เพื่อให้ API ทำงานทีละรายการ
                        for (const [index, value] of data.capturedImages.entries()) {
                            const url = value;
                            // console.log("index:", index, "other_new_obj_id:", responseData.other_new_obj_id[index]);
                            console.log("index:", index, "other_obj_id:", responseData.other_obj_id[index]);
                            if (!isValidUrl(url)) {
                                const imageFormData = new FormData();
                                imageFormData.append('image', value);
                                imageFormData.append('caseID', caseID);
                                imageFormData.append('img_type', "ACCESSORY");
                                // imageFormData.append('obj_id', 'NEW'); // บังคับ New ID
                                // imageFormData.append('obj_id', responseData?.other_new_obj_id[index]); // ID ที่จองไว้ให้รูปที่กำลังจะเพิ่มใหม่
                                imageFormData.append('obj_id', responseData?.other_obj_id[index]);
                                imageFormData.append('new_name', data?.capturedTextImages[index]);
                                
                                console.log("saveImageAPIAndUpdate");
                                // ⭐️ ใช้ await เพื่อรอการ Save Image ให้เสร็จ ก่อนไป Index ถัดไป
                                await saveImageAPIAndUpdate(imageFormData, activeStep, data); 
                            } else {
                                console.log(`add on tab3 index ${index} is url`);
                            }
                        }
                    }else{
                        console.log("else add on tab 3");
                    }

                    // 3. อัปเดต State หลังจาก Save Data และ Image ทั้งหมดเสร็จ
                    if(responseData.maxWheel_latest){
                        console.log("responseData.maxWheel_latest",responseData.maxWheel_latest);
                        //// byPassData.obj_id_MaxWheel = maxWheel_latest.obj_id
                        setByPassData((prev) => {
                            prev.obj_id_MaxWheel = responseData.maxWheel_latest?.obj_id;
                            return prev;
                        });
                        //// dataStep3.has_maxWheel = maxWheel_latest.available
                        setDataStep3((prev) => {
                            prev.has_maxWheel = responseData.maxWheel_latest?.available;
                            return prev;
                        });
                    }

                    // //// เสร็จแล้วไป step ถัดไป
                    // setActiveStep(activeStep + 1);
                    // setBtnLoading(false);
                }else if(activeStep == 4){
                            // console.log("dataStep4",dataStep4); // ค่าเก็บไว้ส่งต่อ
                            // console.log("data",data);   // ค่าที่ได้ตอน submit
                            // console.log("responseData",responseData);   // ค่าที่ตอบกลับจาก api
                    // 2.1 บันทึก 'เล่มทะเบียนรถ'
                    if (data?.imagesCarBook && !isValidUrl(data.imagesCarBook[0])) {
                        console.log("imagesCarBook", "carBook_objID:", responseData.carBook_objID);
                        const imageFormData = new FormData();
                        imageFormData.append('image', [data.imagesCarBook[0]]);
                        imageFormData.append('caseID', caseID);
                        imageFormData.append('img_type', "DOCUMENT");
                        // const obj_id_CarBook = byPassData.obj_id_CarBook || 'NEW';
                        const obj_id_CarBook = byPassData.obj_id_CarBook || responseData.carBook_objID;
                        imageFormData.append('obj_id', obj_id_CarBook);
                        imageFormData.append('new_name', 'เล่มทะเบียนรถ');
                        
                        console.log("saveImageAPI");
                        await saveImageAPI(imageFormData); // ⭐️ await
                    }

                    // 2.2 บันทึก 'เลขตัวถัง'
                    if (data?.imagesCarChassis && !isValidUrl(data.imagesCarChassis[0])) {
                        console.log("imagesCarChassis", "carChassis_objID:", responseData.carChassis_objID);
                        const imageFormData = new FormData();
                        imageFormData.append('image', [data.imagesCarChassis[0]]);
                        imageFormData.append('caseID', caseID);
                        imageFormData.append('img_type', "DOCUMENT");
                        // const obj_id_CarChassis = byPassData.obj_id_CarChassis || 'NEW';
                        const obj_id_CarChassis = byPassData.obj_id_CarChassis || responseData.carChassis_objID;
                        imageFormData.append('obj_id', obj_id_CarChassis);
                        imageFormData.append('new_name', 'เลขตัวถัง');
                        
                        console.log("saveImageAPI");
                        await saveImageAPI(imageFormData); // ⭐️ await
                    }

                    // 2.3 บันทึกรูปภาพ Add On (Loop)
                    if (data?.capturedImages && data.capturedImages.length > 0) {
                        // ⭐️ ใช้ for...of loop เพื่อให้ API ทำงานทีละรายการ
                        for (const [index, value] of data.capturedImages.entries()) {
                            const url = value;
                            console.log("index:", index, "other_obj_id:", responseData.other_obj_id[index]);
                            if (!isValidUrl(url)) {
                                const imageFormData = new FormData();
                                imageFormData.append('image', value);
                                imageFormData.append('caseID', caseID);
                                imageFormData.append('img_type', "DOCUMENT");
                                // imageFormData.append('obj_id', 'NEW'); // บังคับ New ID
                                // imageFormData.append('obj_id', responseData?.other_new_obj_id[index]); // ID ที่จองไว้ให้รูปที่กำลังจะเพิ่มใหม่
                                imageFormData.append('obj_id', responseData?.other_obj_id[index]);
                                imageFormData.append('new_name', data?.capturedTextImages[index]);
                                
                                console.log("saveImageAPIAndUpdate");
                                // ⭐️ ใช้ await เพื่อรอการ Save Image ให้เสร็จ ก่อนไป Index ถัดไป
                                await saveImageAPIAndUpdate(imageFormData, activeStep, data); 
                            } else {
                                console.log(`add on tab4 index ${index} is url`);
                            }
                        }
                    }else{
                        console.log("else add on tab 4");
                    }
                }
            }
            // 3. ไป Step ถัดไปเมื่อทุกอย่างเสร็จสมบูรณ์
            setActiveStep(activeStep + 1);
        } catch (error) {
            console.error("Critical API Error in handleNext:", error);
            // แสดงข้อความผิดพลาดให้ผู้ใช้เห็น
        } finally {
            console.log("finally");
            // 4. ปิดสถานะการโหลด
            setBtnLoading(false);
        }

        // if(activeStep !== 4){ // skip for test some activeStep
            // setActiveStep(activeStep + 1);
        // }
    };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const onSave = (data) => {  // save and next
        console.log("onSave activeStep",activeStep);
        setBtnLoading(true);
        if (activeStep === 0) {
            handleNext();
        } else if (activeStep === 1) {
            // console.log("onSave1 data",data);
            // setDataStep1(data);
            setDataStep1({
                plate_no: data.plate_no,
                ref_no: data.ref_no,
                customer_name: data.customer_name,
                // customer_lastname: data.customer_lastname,
                car_brand: data.car_brand,
                car_model: data.car_model,
                car_brand_desc: data.car_brand_desc,
                car_model_desc: data.car_model_desc,
                // mileage: data.mileage,
                // imageSrc: data.imageSrc,
                capturedImages: data.capturedImages,
            });
            // console.log("data.firstname",data.firstname);
            // setIs_punish(data.is_punish);
            // setEducation_desc(data.education_desc);
          // console.log("step 1");
            handleNext(data);
        } else if (activeStep === 2) {
            console.log("onSave2 data",data);
            setDataStep2({
                capturedImages: data.capturedImages,
            });
            // setDataStep3(data);
            // setSTRAIGHT_FACE(data.STRAIGHT_FACE);
            // setB_account_name(data.b_account_name);
          // console.log("step 2");
            handleNext(data);
        } else if (activeStep === 3) {
            console.log("onSave data",data);
            // console.log("imagesAudioEquipment",[data.imagesAudioEquipment[0]]);

            //// ย้ายมาทำก่อนที่จะ set data ไป dataStep เพราะต้อง update ค่าหลังจาก response จาก API
            // console.log("step 3", dataStep3);
            handleNext(data);

            setDataStep3({
                capturedImages: data.capturedImages,
                capturedTextImages: data.capturedTextImages,
                capturedObjIDImages: data.capturedObjIDImages, // ใช้ ID เพื่อ ref ตอนลบ
                imagesAudioEquipment: data.imagesAudioEquipment && data.imagesAudioEquipment.length > 0 ?
                                        [data.imagesAudioEquipment[0]] : null,
                imagesSpareTire: data.imagesSpareTire && data.imagesSpareTire.length > 0 ?
                                        [data.imagesSpareTire[0]] : null,
                imagesCarCAM: data.imagesCarCAM && data.imagesCarCAM.length > 0 ?
                                        [data.imagesCarCAM[0]] : null,
                imagesMaxWheel: data.imagesMaxWheel && data.imagesMaxWheel.length > 0 ?
                                        [data.imagesMaxWheel[0]] : null,
                has_audio: data.has_audio,
                has_spareTire: data.has_spareTire,
                has_carCAM: data.has_carCAM,
                has_maxWheel: data.has_maxWheel,
            });

            //// ย้ายไปทำก่อนที่จะ set data ไป dataStep เพราะต้อง update ค่าหลังจาก response จาก API
            // // console.log("step 3", dataStep3);
            // handleNext(data);
        }else if(activeStep === 4){
            // console.log("onSave data",data);
            // console.log("imagesAudioEquipment",[data.imagesAudioEquipment[0]]);

            //// ย้ายมาทำก่อนที่จะ set data ไป dataStep เพราะต้อง update ค่าหลังจาก response จาก API
            // console.log("step 4", dataStep4);
            handleNext(data);

            setDataStep4({
                capturedImages: data.capturedImages,
                capturedTextImages: data.capturedTextImages,
                capturedObjIDImages: data.capturedObjIDImages, // ใช้ ID เพื่อ ref ตอนลบ
                imagesCarBook: data.imagesCarBook && data.imagesCarBook.length > 0 ?
                                        [data.imagesCarBook[0]] : null,
                imagesCarTax: data.imagesCarTax && data.imagesCarTax.length > 0 ?
                                        [data.imagesCarTax[0]] : null,
                imagesCarChassis: data.imagesCarChassis && data.imagesCarChassis.length > 0 ?
                                        [data.imagesCarChassis[0]] : null,
                imagesCarLicense: data.imagesCarLicense && data.imagesCarLicense.length > 0 ?
                                        [data.imagesCarLicense[0]] : null,
                has_carBook: data.has_carBook,
                has_carTax: data.has_carTax,
                has_carChassis: data.has_carChassis,
                has_carLicense: data.has_carLicense,
            });

            //// ย้ายไปทำก่อนที่จะ set data ไป dataStep เพราะต้อง update ค่าหลังจาก response จาก API
            // // console.log("step 4", dataStep4);
            // handleNext(data);
        }else if(activeStep === 5){
            // console.log("onSave data",data);
            setDataStep5({
                has_damaged: data.has_damaged,
                // listDamage: data.listDamage,
                damage_detail: data.damage_detail,
                capturedImages: data.capturedImages,
            });
          // console.log("step 5");
          handleNext(data);
        }else if(activeStep === 6){
          // console.log("step 6");
          // handleNext();
          //// call API to save data to DB ////
          saveInspectionResult();
        }else{
            // console.log("activeStep else");
          handleNext();
        }

        // console.log("receive data",data);
        // console.log("dataStep5",dataStep5); // Calling the set function does not change the current state in the already executing code
    };

    const saveData = (data) => {
        // console.log("saveData activeStep",activeStep,data);
        if(data){
            if(activeStep === 2){
                setDataStep2({
                    capturedImages: data,
                });
            }else if(activeStep === 3){
                setDataStep3({
                    capturedImages: data.capturedImages,
                    capturedTextImages: data.capturedTextImages,
                    capturedObjIDImages: data.capturedObjIDImages,
                    imagesAudioEquipment: data.imagesAudioEquipment && data.imagesAudioEquipment.length > 0 ?
                                            [data.imagesAudioEquipment[0]] : null,
                    imagesSpareTire: data.imagesSpareTire && data.imagesSpareTire.length > 0 ?
                                            [data.imagesSpareTire[0]] : null,
                    imagesCarCAM: data.imagesCarCAM && data.imagesCarCAM.length > 0 ?
                                            [data.imagesCarCAM[0]] : null,
                    imagesMaxWheel: data.imagesMaxWheel && data.imagesMaxWheel.length > 0 ?
                                            [data.imagesMaxWheel[0]] : null,
                    has_audio: data.has_audio,
                    has_spareTire: data.has_spareTire,
                    has_carCAM: data.has_carCAM,
                    has_maxWheel: data.has_maxWheel,
                });
            }else if(activeStep === 4){
                setDataStep4({
                    capturedImages: data.capturedImages,
                    capturedTextImages: data.capturedTextImages,
                    capturedObjIDImages: data.capturedObjIDImages,
                    imagesCarBook: data.imagesCarBook && data.imagesCarBook.length > 0 ?
                                            [data.imagesCarBook[0]] : null,
                    imagesCarTax: data.imagesCarTax && data.imagesCarTax.length > 0 ?
                                            [data.imagesCarTax[0]] : null,
                    imagesCarChassis: data.imagesCarChassis && data.imagesCarChassis.length > 0 ?
                                            [data.imagesCarChassis[0]] : null,
                    imagesCarLicense: data.imagesCarLicense && data.imagesCarLicense.length > 0 ?
                                            [data.imagesCarLicense[0]] : null,
                    has_carBook: data.has_carBook,
                    has_carTax: data.has_carTax,
                    has_carChassis: data.has_carChassis,
                    has_carLicense: data.has_carLicense,
                });
            }else if(activeStep === 5){
                setDataStep5({
                    has_damaged: data.has_damaged,
                    // listDamage: data.listDamage,
                    damage_detail: data.damage_detail,
                    capturedImages: data.capturedImages,
                });
            }
        }
        // console.log("dataStep5",dataStep5);
    };

    const saveAndBack = (data) =>{
        // console.log("saveAndBack",data);
        // console.log("===activeStep===",activeStep);
        if(activeStep === 2){
            saveData(data);
            handleBack();
        }else if(activeStep === 3){
            saveData(data);
            handleBack();
        }else if(activeStep === 4){
            saveData(data);
            handleBack();
        }else if(activeStep === 5){
            saveData(data);
            handleBack();
        }
    };

    const getStepContent = (step) => {
        // console.log("step ==",step);
        // console.log("dataStep1",dataStep1);
        switch (step) {
            case 1:
                return <CarInfoForm onSave={onSave} initalData={initalData} dataStep={dataStep1} btnLoading={btnLoading}/>;
            case 2:
                return <AllRoundPhotoForm onSave={onSave} dataStep={dataStep2} saveAndBack={saveAndBack} btnLoading={btnLoading}/>;
            case 3:
                return <AccessoryForm onSave={onSave} dataStep={dataStep3} saveAndBack={saveAndBack} btnLoading={btnLoading}/>;
            case 4:
                return <DocumentForm onSave={onSave} dataStep={dataStep4} saveAndBack={saveAndBack} btnLoading={btnLoading}/>;
            case 5:
                return <DamagedPartForm onSave={onSave} dataStep={dataStep5} saveAndBack={saveAndBack} btnLoading={btnLoading}/>;
            case 6:
                return <InspectionResultForm 
                            onSave={onSave}
                            handleBack={handleBack}
                            initalData={initalData}
                            dataStep1={dataStep1}
                            dataStep2={dataStep2}
                            dataStep3={dataStep3}
                            dataStep4={dataStep4}
                            dataStep5={dataStep5}
                        />;
            default:
                throw new Error("Unknown step");
        }
    };

    useEffect(() => {
        // console.log("width", windowWidth);
        // console.log("height", windowHeight);

        getData();
    }, []);

    const handleGetData = (ref_no, tab) => {
        let qString = '?';
        if(ref_no){
            qString += 'rNo='+ref_no;
        }
        if(caseID){
            qString += '&cID='+caseID;
        }
        // if(tab == 1){
        //     setLoading(true);
        //     GetCaseStep(qString, tab).then(response => {
        //         if (response && response.status === 200) {
        //             setLoading(false);
        //             setInitalData(response.data);
        //             setAllDataStep(response.data);
        //         }else if (response && response.data){
        //             console.log("API response error ["+ response.status + "]", response.data.message);
        //         }else{
        //             console.log("API response error", response);
        //         }
        //     })
        // }else{
        //     console.log("handleGetData else");
        // }

            //// call API to get data from DB //// ==> get ทีละ tab แล้ว มันต้องแก้หน้าอื่นๆอีก ละเอียดเกินไป เอามันทั้งหมดไปก่อนละกัน
            setLoading(true);
            GetInspectionCase(qString).then(response => {
                // console.log(response);
                // this.setState({loading: false});

                // console.log(response.data.data);
                // console.log(response.data.data[0].dispatch[0].surveyor_name);

                if (response && response.status === 200) {
                    // console.log("response.data", response.data);
                    setInitalData(response.data);
                    // let noitfyData = response.data.notify[0];
                    // console.log("noitfyData", noitfyData);
                    // setInitalData(noitfyData);
                    // console.log("initalData will set", response.data);

                        ////////// pre set all datastep //////////
                        setAllDataStep(response.data);
                        // let noitfyData = response.data.notify[0];
                        // let mileImage = response.data.mile[0];
                        // if(mileImage){
                        //     noitfyData.capturedImages = mileImage.image[0];
                        // }
                        // console.log("noitfyData", noitfyData);
                        // setDataStep1({
                        //     plate_no: noitfyData.plate_no,
                        //     ref_no: noitfyData.ref_no,
                        //     customer_name: noitfyData.customer_name,
                        //     // customer_lastname: noitfyData.customer_lastname,
                        //     car_brand: noitfyData.car_brand,
                        //     car_model: noitfyData.car_model,
                        //     mileage: noitfyData.mileage,
                        //     // imageSrc: noitfyData.imageSrc,
                        //     capturedImages: [noitfyData.capturedImages],
                        // });
                        ////////////////////////////////////////

                    setLoading(false);
                }else if (response && response.data){
                    console.log("API response error ["+ response.status + "]", response.data.message);
                }else{
                    console.log("API response error", response);
                }
            })
            ////////////////////////////////////////////////////////////
    };

    const getData = () => {
        // console.log("regis getData");
        if(encodedrNO && encodedcID){
            // let qString = '?rNo=XXX202209-14808';
            // console.log("ref_no", ref_no);
            let qString = '?';
            if(ref_no){
                qString += 'rNo='+ref_no;
            }
            if(caseID){
                qString += '&cID='+caseID;
            }
            // console.log("qString",qString);

            // //// pre get data tab 1 //// ==> get ทีละ tab แล้ว มันต้องแก้หน้าอื่นๆอีก ละเอียดเกินไป เอามันทั้งหมดไปก่อนละกัน
            // handleGetData(ref_no, 1);

            //// call API to get data from DB ////
            setLoading(true);
            GetInspectionCase(qString).then(response => {
                // console.log(response);
                // this.setState({loading: false});

                // console.log(response.data.data);
                // console.log(response.data.data[0].dispatch[0].surveyor_name);

                if (response && response.status === 200) {
                    // console.log("response.data", response.data);
                    setInitalData(response.data);
                    // let noitfyData = response.data.notify[0];
                    // console.log("noitfyData", noitfyData);
                    // setInitalData(noitfyData);
                    // console.log("initalData will set", response.data);

                        ////////// pre set all datastep //////////
                        setAllDataStep(response.data);
                        // let noitfyData = response.data.notify[0];
                        // let mileImage = response.data.mile[0];
                        // if(mileImage){
                        //     noitfyData.capturedImages = mileImage.image[0];
                        // }
                        // console.log("noitfyData", noitfyData);
                        // setDataStep1({
                        //     plate_no: noitfyData.plate_no,
                        //     ref_no: noitfyData.ref_no,
                        //     customer_name: noitfyData.customer_name,
                        //     // customer_lastname: noitfyData.customer_lastname,
                        //     car_brand: noitfyData.car_brand,
                        //     car_model: noitfyData.car_model,
                        //     mileage: noitfyData.mileage,
                        //     // imageSrc: noitfyData.imageSrc,
                        //     capturedImages: [noitfyData.capturedImages],
                        // });
                        ////////////////////////////////////////

                    setLoading(false);
                }else if (response && response.data){
                    console.log("API response error ["+ response.status + "]", response.data.message);
                }else{
                    console.log("API response error", response);
                }
            })

        }else{
          alert("parameter ไม่ถูกต้อง");
          return;
        }

    };

    ////////// pre set all data step /////////
    const setAllDataStep = (data) => {
        console.log("setAllDataStep", data);

        if(data){
            let noitfyData = data.notify[0];
            let mileImage = data.mile[0];
            if(mileImage){
                noitfyData.capturedImages = mileImage.image[0];
            }
            // console.log("noitfyData", noitfyData);
            setDataStep1({
                plate_no: noitfyData.plate_no,
                ref_no: noitfyData.ref_no,
                customer_name: noitfyData.customer_name,
                // customer_lastname: noitfyData.customer_lastname,
                    //// test - fixed data ////
                    // car_brand: "BNK",
                    // car_model: "BNK",
                    //// skip for test //// BNK
                    car_brand: noitfyData.car_brand,
                    car_model: noitfyData.car_model,
                // car_brand: parseInt(noitfyData.car_brandID),
                // car_model: parseInt(noitfyData.car_model),
                // mileage: noitfyData.mileage,
                // imageSrc: noitfyData.imageSrc,
                capturedImages: [noitfyData.capturedImages],

                // plate_province_desc: noitfyData.plate_province_desc,
                // car_color: noitfyData.car_color,
                // chassis_no: noitfyData.chassis_no,
                // engine_no: noitfyData.engine_no,
            });
            // console.log("setDataStep1", dataStep1);

            //// setDataStep2
            let vehPartData = data.vehPart;
            let Dtap2 = [];
            // console.log("vehPart",vehPartData);
                vehPartData?.forEach((value, index) => {
                    // console.log(`vehPartData[${index}]`, value);
                    if(value.img_type == "VEH_FRONT_LEFT"){
                        Dtap2["VEH_FRONT_LEFT"] = value.image[0];   // set ให้เหมือนตอน capture จะได้ loop ตอน save ได้ง่ายๆ
                    }
                    if(value.img_type == "VEH_FRONT"){
                        Dtap2["VEH_FRONT"] = value.image[0];
                    }
                    if(value.img_type == "VEH_FRONT_RIGHT"){
                        Dtap2["VEH_FRONT_RIGHT"] = value.image[0];
                    }
                    if(value.img_type == "VEH_BACK_LEFT"){
                        Dtap2["VEH_BACK_LEFT"] = value.image[0];
                    }
                    if(value.img_type == "VEH_BACK"){
                        Dtap2["VEH_BACK"] = value.image[0];
                    }
                    if(value.img_type == "VEH_BACK_RIGHT"){
                        Dtap2["VEH_BACK_RIGHT"] = value.image[0];
                    }
                    if(value.img_type == "VEH_ENGINE"){
                        Dtap2["VEH_ENGINE"] = value.image[0];
                    }
                    if(value.img_type == "VEH_FRONT_CONSOLE"){
                        Dtap2["VEH_FRONT_CONSOLE"] = value.image[0];
                    }
                });
            setDataStep2({
                capturedImages: [
                    Dtap2["VEH_FRONT_LEFT"], Dtap2["VEH_FRONT"], Dtap2["VEH_FRONT_RIGHT"],
                    Dtap2["VEH_BACK_LEFT"], Dtap2["VEH_BACK"], Dtap2["VEH_BACK_RIGHT"],
                    Dtap2["VEH_ENGINE"], Dtap2["VEH_FRONT_CONSOLE"]
                ]
            });

            ////////// setDataStep3
            let accessoryData = data.accessory;
            let Dtap3 = [];
            let capturedImages3 = [];
            let capturedTextImages3 = [];
            let capturedObjIDImages3 = [];
            let addOnIndex3 = 0;
                let maxWheelIsExists = false;
                accessoryData?.forEach((value, index) => {
                    // console.log(`accessoryData[${index}]`, value);
                    // console.log("value.partname",value.partname);
                    if(value.partname == "เครื่องเสียง"){
                        // console.log("value.partname == เครื่องเสียง");
                        // console.log("value.image",value.image);
                        let audioIsExist = value.image.length > 0 ? 1:0;
                        // console.log("audioIsExist length",audioIsExist);
                        // setDataStep3({
                        //     imagesAudioEquipment: [value.image],
                        //     obj_id_AudioEquipment: value.obj_id,
                        //     has_audio: audioIsExist,
                        // })
                        if(audioIsExist){
                            Dtap3["imagesAudioEquipment"] = [value.image[0]];
                            Dtap3["obj_id_AudioEquipment"] = value.obj_id;
                        }else{
                            Dtap3["imagesAudioEquipment"] = null;
                            Dtap3["obj_id_AudioEquipment"] = null;
                        }
                        Dtap3["has_audio"] = audioIsExist;
                    }else
                    if(value.partname == "ยางอะไหล่"){
                        // console.log("value.partname == ยางอะไหล่");
                        // console.log("value.image",value.image);
                        let spareTireIsExist = value.image.length > 0 ? 1:0;
                        // setDataStep3({
                        //     imagesSpareTire: [value.image],
                        //     obj_id_SpareTire: value.obj_id,
                        //     has_spareTire: spareTireIsExist,
                        // })
                        if(spareTireIsExist){
                            Dtap3["imagesSpareTire"] = [value.image[0]];
                            Dtap3["obj_id_SpareTire"] = value.obj_id;
                        }else{
                            Dtap3["imagesSpareTire"] = null;
                            Dtap3["obj_id_SpareTire"] = null;
                        }
                        Dtap3["has_spareTire"] = spareTireIsExist;
                    }else
                    if(value.partname == "กล้องหน้ารถยนต์"){
                        let carCAMIsExist = value.image.length > 0 ? 1:0;
                        // setDataStep3({
                        //     imagesCarCAM: value.image,
                        //     obj_id_CarCAM: value.obj_id,
                        // })
                        if(carCAMIsExist){
                            Dtap3["imagesCarCAM"] = [value.image[0]];
                            Dtap3["obj_id_CarCAM"] = value.obj_id;
                        }else{
                            Dtap3["imagesCarCAM"] = null;
                            Dtap3["obj_id_CarCAM"] = null;
                        }
                        Dtap3["has_carCAM"] = carCAMIsExist;
                    }else
                    if(value.partname == "ล้อแม็ก"){ // ล้อแม็ก ไม่จำเป็นต้องมีรูป แค่ save ว่ามี/ไม่มี
                        // let maxWheelIsExist = value.image.length > 0 ? 1:0;
                        // // setDataStep3({
                        // //     imagesMaxWheel: value.image,
                        // //     obj_id_MaxWheel: value.obj_id,
                        // // })
                        // if(maxWheelIsExist){
                        //     Dtap3["imagesMaxWheel"] = [value.image[0]];
                        //     Dtap3["obj_id_MaxWheel"] = value.obj_id;
                        // }else{
                        //     Dtap3["imagesMaxWheel"] = null;
                        //     Dtap3["obj_id_MaxWheel"] = null;
                        // }
                        // Dtap3["has_maxWheel"] = maxWheelIsExist;
                        Dtap3["obj_id_MaxWheel"] = value.obj_id;
                        Dtap3["has_maxWheel"] = value.available;
                        maxWheelIsExists = true;
                    }else{
                        // console.log("addOnIndex",addOnIndex3);
                        capturedImages3[addOnIndex3] = value.image[0];
                        capturedTextImages3[addOnIndex3] = value.partname; // tab3 - partname, tab4 - document
                        capturedObjIDImages3[addOnIndex3] = value.obj_id;
                        addOnIndex3++;
                    }
                });
                    // // กรณีที่ accessoryData ยังไม่มี data ของ 'ล้อแม็ก' จะต้องค่า default
                    // if(!maxWheelIsExists){
                    //     Dtap3["obj_id_MaxWheel"] = null;
                    //     Dtap3["has_maxWheel"] = 0;
                    // }
                setDataStep3({
                    capturedImages: capturedImages3,
                    capturedTextImages: capturedTextImages3,
                    capturedObjIDImages: capturedObjIDImages3,
                    imagesAudioEquipment: Dtap3["imagesAudioEquipment"],
                    imagesSpareTire: Dtap3["imagesSpareTire"],
                    imagesCarCAM: Dtap3["imagesCarCAM"],
                    imagesMaxWheel: Dtap3["imagesMaxWheel"],
                    obj_id_AudioEquipment: Dtap3["obj_id_AudioEquipment"],
                    obj_id_SpareTire: Dtap3["obj_id_SpareTire"],
                    obj_id_CarCAM: Dtap3["obj_id_CarCAM"],
                    obj_id_MaxWheel: Dtap3["obj_id_MaxWheel"],
                    has_audio: Dtap3["has_audio"],
                    has_spareTire: Dtap3["has_spareTire"],
                    has_carCAM: Dtap3["has_carCAM"],
                    has_maxWheel: Dtap3["has_maxWheel"],
                });
            // console.log("setDataStep3", dataStep3);
            
            ////////// setDataStep4
            let documentData = data.document;
            let Dtap4 = [];
            let capturedImages4 = [];
            let capturedTextImages4 = [];
            let capturedObjIDImages4 = [];
            let addOnIndex4 = 0;
                documentData?.forEach((value, index) => {
                    // console.log(`documentData[${index}]`, value);
                    // console.log("value.document",value.document);
                    if(value.document == "เล่มทะเบียนรถ"){
                        // console.log("value.document == เล่มทะเบียนรถ");
                        // console.log("value.image",value.image);
                        let carBookIsExist = value.image.length > 0 ? 1:0;
                        // console.log("carBookIsExist length",carBookIsExist);
                        if(carBookIsExist){
                            Dtap4["imagesCarBook"] = [value.image[0]];
                            Dtap4["obj_id_CarBook"] = value.obj_id;
                        }else{
                            Dtap4["imagesCarBook"] = null;
                            Dtap4["obj_id_CarBook"] = null;
                        }
                        Dtap4["has_carBook"] = carBookIsExist;
                    // }else
                    // if(value.document == "ป้ายภาษีรถยนต์"){
                    //     // console.log("value.document == ป้ายภาษีรถยนต์");
                    //     // console.log("value.image",value.image);
                    //     let carTaxIsExist = value.image.length > 0 ? 1:0;
                    //     if(carTaxIsExist){
                    //         Dtap4["imagesCarTax"] = [value.image[0]];
                    //         Dtap4["obj_id_CarTax"] = value.obj_id;
                    //     }else{
                    //         Dtap4["imagesCarTax"] = null;
                    //         Dtap4["obj_id_CarTax"] = null;
                    //     }
                    //     Dtap4["has_carTax"] = carTaxIsExist;
                    }else
                    if(value.document == "เลขตัวถัง"){
                        // console.log("value.document == เลขตัวถัง");
                        // console.log("value.image",value.image);
                        let carChassisIsExist = value.image.length > 0 ? 1:0;
                        if(carChassisIsExist){
                            Dtap4["imagesCarChassis"] = [value.image[0]];
                            Dtap4["obj_id_CarChassis"] = value.obj_id;
                        }else{
                            Dtap4["imagesCarChassis"] = null;
                            Dtap4["obj_id_CarChassis"] = null;
                        }
                        Dtap4["has_carChassis"] = carChassisIsExist;
                    // }else
                    // if(value.document == "ใบอนุญาติขับขี่ / บัตรประชาชน"){
                    //     // console.log("value.document == ใบอนุญาติขับขี่ / บัตรประชาชน");
                    //     // console.log("value.image",value.image);
                    //     let carLicenseIsExist = value.image.length > 0 ? 1:0;
                    //     if(carLicenseIsExist){
                    //         Dtap4["imagesCarLicense"] = [value.image[0]];
                    //         Dtap4["obj_id_CarLicense"] = value.obj_id;
                    //     }else{
                    //         Dtap4["imagesCarLicense"] = null;
                    //         Dtap4["obj_id_CarLicense"] = null;
                    //     }
                    //     Dtap4["has_carLicense"] = carLicenseIsExist;
                    }else{
                        // console.log("addOnIndex",addOnIndex4);
                        capturedImages4[addOnIndex4] = value.image[0];
                        capturedTextImages4[addOnIndex4] = value.document; // tab3 - partname, tab4 - document
                        capturedObjIDImages4[addOnIndex4] = value.obj_id;
                        addOnIndex4++;
                    }
                });
                setDataStep4({
                    capturedImages: capturedImages4,
                    capturedTextImages: capturedTextImages4,
                    capturedObjIDImages: capturedObjIDImages4,
                    imagesCarBook: Dtap4["imagesCarBook"],
                    imagesCarTax: Dtap4["imagesCarTax"],
                    imagesCarChassis: Dtap4["imagesCarChassis"],
                    imagesCarLicense: Dtap4["imagesCarLicense"],
                    obj_id_CarBook: Dtap4["obj_id_CarBook"],
                    obj_id_CarTax: Dtap4["obj_id_CarTax"],
                    obj_id_CarChassis: Dtap4["obj_id_CarChassis"],
                    obj_id_CarLicense: Dtap4["obj_id_CarLicense"],
                    has_carBook: Dtap4["has_carBook"],
                    has_carTax: Dtap4["has_carTax"],
                    has_carChassis: Dtap4["has_carChassis"],
                    has_carLicense: Dtap4["has_carLicense"],
                });
            console.log("setDataStep4", dataStep4);

            ////////// setDataStep5
            let damage_detail = data.damagePart_memo;
            let has_damaged = 0;
            if(damage_detail){
                has_damaged = 1;
            }
            let damageOther = data.other;
            let capturedImages5 = [];
                damageOther?.forEach((value, index) => {
                    // console.log(`damageOther[${index}]`, value);
                    capturedImages5[index] = value.image[0];
                });
            setDataStep5({
                has_damaged: has_damaged,
                // listDamage: data.listDamage,
                damage_detail: damage_detail,
                capturedImages: capturedImages5,
            });

            ////////// tab6 จะมีบางค่า ที่ไม่ได้อยู่ใน tab ก่อนๆ
            setInitalData(noitfyData);
            setByPassData({
                obj_id_AudioEquipment: Dtap3["obj_id_AudioEquipment"],
                obj_id_SpareTire: Dtap3["obj_id_SpareTire"],
                obj_id_CarCAM: Dtap3["obj_id_CarCAM"],
                obj_id_MaxWheel: Dtap3["obj_id_MaxWheel"],
                obj_id_CarBook: Dtap4["obj_id_CarBook"],
                obj_id_CarTax: Dtap4["obj_id_CarTax"],
                obj_id_CarChassis: Dtap4["obj_id_CarChassis"],
                obj_id_CarLicense: Dtap4["obj_id_CarLicense"],
            });
        }
    };

    //// call API to save data to DB ////   ===> save data อย่างเดียวก่อน save รูปทีหลัง
    const saveInspectionResult = () => {
        let sendData = new FormData();
        // console.log("byPassData",byPassData);
        sendData.append('caseID', caseID);
        setLoading(true);
        if(dataStep1){
            sendData.append('plate_no', dataStep1.plate_no);
            sendData.append('ref_no', dataStep1.ref_no);
            sendData.append('customer_name', dataStep1.customer_name);
            sendData.append('car_brand', dataStep1.car_brand);
            sendData.append('car_model', dataStep1.car_model);
            // sendData.append('mileage', dataStep1.mileage);
            // sendData.append('capturedImages1', dataStep1.capturedImages);
        }

        if(dataStep3){
            sendData.append("accessory[audio][obj_id_AudioEquipment]", byPassData.obj_id_AudioEquipment);
            sendData.append("accessory[audio][partname]", "เครื่องเสียง");
            sendData.append("accessory[audio][part_detail]", "เครื่องเสียง");
            sendData.append("accessory[audio][available]", dataStep3.imagesAudioEquipment && dataStep3.imagesAudioEquipment.length > 0 ? 1 : 0);

            sendData.append("accessory[spareTire][obj_id_SpareTire]", byPassData.obj_id_SpareTire);
            sendData.append("accessory[spareTire][partname]", "ยางอะไหล่");
            sendData.append("accessory[spareTire][part_detail]", "ยางอะไหล่");
            sendData.append("accessory[spareTire][available]", dataStep3.imagesSpareTire && dataStep3.imagesSpareTire.length > 0 ? 1 : 0);

            sendData.append("accessory[carCAM][obj_id_CarCAM]", byPassData.obj_id_CarCAM);
            sendData.append("accessory[carCAM][partname]", "กล้องหน้ารถยนต์");
            sendData.append("accessory[carCAM][part_detail]", "กล้องหน้ารถยนต์");
            sendData.append("accessory[carCAM][available]", dataStep3.imagesCarCAM && dataStep3.imagesCarCAM.length > 0 ? 1 : 0);
           
            sendData.append("accessory[maxWheel][obj_id_MaxWheel]", byPassData.obj_id_MaxWheel);
            sendData.append("accessory[maxWheel][partname]", "ล้อแม็ก");
            sendData.append("accessory[maxWheel][part_detail]", "ล้อแม็ก");
            // sendData.append("accessory[maxWheel][available]", dataStep3.imagesMaxWheel && dataStep3.imagesMaxWheel.length > 0 ? 1 : 0);
            sendData.append("accessory[maxWheel][available]", dataStep3.has_maxWheel ? dataStep3.has_maxWheel : null);


            // if(dataStep3.capturedImages){
            //     console.log("dataStep3.capturedImages.length", dataStep3.capturedImages.length);
            // }
            // console.log("dataStep3.capturedImages",dataStep3.capturedImages);
            // console.log("dataStep3.capturedTextImages",dataStep3.capturedTextImages);
                    // capturedImages: capturedImages3,
                    // capturedTextImages: capturedTextImages3,
            dataStep3?.capturedImages.forEach((value, index) => {
                // console.log(`capturedImages3[${index}]`, value);
                var url = value;
                if(isValidUrl(url)){
                    var chkValue = value.split('?')[0];
                    sendData.append("accessory[other_image]["+index+"]", chkValue);
                    // sendData.append("accessory[other_text]["+index+"]", dataStep3.capturedTextImages[index]);
                }else{ 
                    // console.log("add on tab3 index", index, " is not url"); 
                    sendData.append("accessory[other_image]["+index+"]", value);
                }
                
                // sendData.append("accessory[other_image]["+index+"]", value);
                sendData.append("accessory[other_text]["+index+"]", dataStep3.capturedTextImages[index]);
            });
        }
        if(dataStep4){
            sendData.append("document[carBook][imagesCarBook]", dataStep4.imagesCarBook);
            sendData.append("document[carBook][obj_id_CarBook]", byPassData.obj_id_CarBook);
            sendData.append("document[carBook][partname]", "เล่มทะเบียนรถ");
            sendData.append("document[carBook][part_detail]", "เล่มทะเบียนรถ");
            sendData.append("document[carBook][available]", dataStep4.imagesCarBook && dataStep4.imagesCarBook.length > 0 ? 1 : 0);

            sendData.append("document[carTax][obj_id_CarTax]", byPassData.obj_id_CarTax);
            sendData.append("document[carTax][partname]", "ป้ายภาษีรถยนต์");
            sendData.append("document[carTax][part_detail]", "ป้ายภาษีรถยนต์");
            sendData.append("document[carTax][available]", dataStep4.imagesCarTax && dataStep4.imagesCarTax.length > 0 ? 1 : 0);

            sendData.append("document[carChassis][obj_id_CarChassis]", byPassData.obj_id_CarChassis);
            sendData.append("document[carChassis][partname]", "เลขตัวถัง");
            sendData.append("document[carChassis][part_detail]", "เลขตัวถัง");
            sendData.append("document[carChassis][available]", dataStep4.imagesCarChassis && dataStep4.imagesCarChassis.length > 0 ? 1 : 0);
            
            sendData.append("document[carLicense][obj_id_CarLicense]", byPassData.obj_id_CarLicense);
            sendData.append("document[carLicense][partname]", "ใบอนุญาติขับขี่ / บัตรประชาชน");
            sendData.append("document[carLicense][part_detail]", "ใบอนุญาติขับขี่ / บัตรประชาชน");
            sendData.append("document[carLicense][available]", dataStep4.imagesCarLicense && dataStep4.imagesCarLicense.length > 0 ? 1 : 0);

            // console.log("dataStep4.capturedImages",dataStep4.capturedImages);
            // console.log("dataStep4.capturedTextImages",dataStep4.capturedTextImages);
                    // capturedImages: capturedImages4,
                    // capturedTextImages: capturedTextImages4,
            dataStep4?.capturedImages.forEach((value, index) => {
                // console.log(`capturedImages4[${index}]`, value);
                var url = value;
                if(isValidUrl(url)){
                    var chkValue = value.split('?')[0];
                    sendData.append("document[other_image]["+index+"]", chkValue);
                    // sendData.append("document[other_text]["+index+"]", dataStep4.capturedTextImages[index]);
                }else{ 
                    // console.log("add on tab4 index", index, " is not url"); 
                    sendData.append("document[other_image]["+index+"]", value);
                }

                // sendData.append("document[other_image]["+index+"]", value);
                sendData.append("document[other_text]["+index+"]", dataStep4.capturedTextImages[index]);
            });
        }
        if(dataStep5){
            sendData.append('has_damaged', dataStep5.has_damaged);
            sendData.append('damage_detail', dataStep5.damage_detail);
            // sendData.append('capturedImages5', dataStep5.capturedImages);
            // console.log("dataStep5.capturedImages",dataStep5.capturedImages);
            dataStep5?.capturedImages.forEach((value, index) => {
                // console.log(`capturedImages5[${index}]`, value);
                // console.log("tt", value.split('?')[0]);
                var url = value;
                if(isValidUrl(url)){
                    var chkValue = value.split('?')[0];
                    sendData.append("damaged[other]["+index+"]", chkValue);
                }else{ console.log("add on tab5 index", index, " is not url"); }
            });
        }
        // console.log("sendData", sendData);
        SaveInspection(sendData).then(response => {
            // console.log("response", response);
            // this.setState({loading: false});

            // console.log(response.data.data);
            // console.log(response.data.data[0].dispatch[0].surveyor_name);

            if (response && response.status === 200) {
                // console.log("response.data", response.data);
                // console.log("response.data caseID", response.data.claim.caseID);
            //     setInitalData(response.data);
            //     // console.log("initalData will set", response.data);
                setLoading(false);
                saveInspectionImage(response.data.caseID);

                //// go to end page //// <CompletedComponent />
                setCompleted(true);
            }else if (response && response.data){
                console.log("API response error ["+ response.status + "]", response.data.message);
            }else{
                console.log("API response error", response);
            }
        })
    };

    const isValidUrl = urlString=> {
          var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
        '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
      return !!urlPattern.test(urlString);
    }

    //// handle data and image for call api  ////
    const saveInspectionImage = (caseID) => {
        // console.log("saveInspectionImage");
        // setLoading(true);
        let sendData = new FormData();

        // var url = "invalidURL";
        // console.log(isValidUrl(url));

        // ////// mile //////
        console.log("dataStep1", dataStep1);
        var url_tab1 = dataStep1.capturedImages;
        console.log(isValidUrl(url_tab1));
        if(!isValidUrl(url_tab1)){
            sendData.append('image', dataStep1.capturedImages);
            sendData.append('caseID', caseID);
            sendData.append('img_type', "MILE");
            // sendData.append('name', "mileage");
            saveImageAPI(sendData);
        }else{ console.log("url_tab1 is url"); }

        ////// 9side //////
        if(dataStep2){
            // console.log("dataStep2.capturedImages",dataStep2.capturedImages);
            if(dataStep2.capturedImages && dataStep2.capturedImages != "undefined"){
                dataStep2.capturedImages.forEach((value, index) => {
                    // sendData.append(`capturedImages2[${index}]`, value);
                    // console.log(`capturedImages2[${index}]`, value);
                    // console.log("image ==",value);
                    var url = value;
                    if(!isValidUrl(url)){
                        sendData = new FormData();
                        sendData.append('image', value);
                        sendData.append('caseID', caseID);
                        if(index == 0){ // for test
                            sendData.append('img_type', "VEH_FRONT_LEFT");
                            sendData.append('name', "VEH_FRONT_LEFT");
                        }else if(index == 1){
                            sendData.append('img_type', "VEH_FRONT");
                            sendData.append('name', "VEH_FRONT");
                        }else if(index == 2){
                            sendData.append('img_type', "VEH_FRONT_RIGHT");
                            sendData.append('name', "VEH_FRONT_RIGHT");
                        }else if(index == 3){
                            sendData.append('img_type', "VEH_BACK_LEFT");
                            sendData.append('name', "VEH_BACK_LEFT");
                        }else if(index == 4){
                            sendData.append('img_type', "VEH_BACK");
                            sendData.append('name', "VEH_BACK");
                        }else if(index == 5){
                            sendData.append('img_type', "VEH_BACK_RIGHT");
                            sendData.append('name', "VEH_BACK_RIGHT");
                        }else if(index == 6){
                            sendData.append('img_type', "VEH_ENGINE");
                            sendData.append('name', "VEH_ENGINE");
                        }else if(index == 7){
                            sendData.append('img_type', "VEH_FRONT_CONSOLE");
                            sendData.append('name', "VEH_FRONT_CONSOLE");
                        }else{} // ยังไม่รู้ว่าจะดักว่าอะไร
                        saveImageAPI(sendData);
                    }else{ console.log("tab2 index", index, " is url"); }
                });
            }
        }

        ////// accessory ////// audio
        if(dataStep3){
            if(dataStep3.imagesAudioEquipment){
                var url = dataStep3.imagesAudioEquipment[0];
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', [dataStep3.imagesAudioEquipment[0]]);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "ACCESSORY");
                    sendData.append('name', "ACCESSORY");
                    // sendData.append('obj_id', byPassData.obj_id_AudioEquipment?byPassData.obj_id_AudioEquipment:"NEW");
                    let obj_id_AudioEquipment = byPassData.obj_id_AudioEquipment?byPassData.obj_id_AudioEquipment:null;
                    if(obj_id_AudioEquipment){
                        sendData.append('obj_id', byPassData.obj_id_AudioEquipment);
                    }else{
                        sendData.append('obj_id', 'NEW');
                        sendData.append('new_name', 'เครื่องเสียง');
                    }
                    saveImageAPI(sendData);
                }else{ console.log("audio tab3 is url"); }
            }
            if(dataStep3.imagesSpareTire){
                var url = dataStep3.imagesSpareTire[0];
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', [dataStep3.imagesSpareTire[0]]);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "ACCESSORY");
                    sendData.append('name', "ACCESSORY");
                    // sendData.append('obj_id', byPassData.obj_id_SpareTire?byPassData.obj_id_SpareTire:"NEW");
                    let obj_id_SpareTire = byPassData.obj_id_SpareTire?byPassData.obj_id_SpareTire:null;
                    if(obj_id_SpareTire){
                        sendData.append('obj_id', byPassData.obj_id_SpareTire);
                    }else{
                        sendData.append('obj_id', 'NEW');
                        sendData.append('new_name', 'ยางอะไหล่');
                    }
                    saveImageAPI(sendData);
                }else{ console.log("spareTire tab3 is url"); }
            }
            if(dataStep3.imagesCarCAM){
                var url = dataStep3.imagesCarCAM[0];
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', [dataStep3.imagesCarCAM[0]]);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "ACCESSORY");
                    sendData.append('name', "ACCESSORY");
                    // sendData.append('obj_id', byPassData.obj_id_CarCAM);
                    let obj_id_CarCAM = byPassData.obj_id_CarCAM?byPassData.obj_id_CarCAM:null;
                    if(obj_id_CarCAM){
                        sendData.append('obj_id', byPassData.obj_id_CarCAM);
                    }else{
                        sendData.append('obj_id', 'NEW');
                        sendData.append('new_name', 'กล้องหน้ารถยนต์');
                    }
                    saveImageAPI(sendData);
                }else{ console.log("carCAM tab3 is url"); }
            }
            if(dataStep3.imagesMaxWheel){
                var url = dataStep3.imagesMaxWheel[0];
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', [dataStep3.imagesMaxWheel[0]]);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "ACCESSORY");
                    sendData.append('name', "ACCESSORY");
                    // sendData.append('obj_id', byPassData.obj_id_MaxWheel);
                    let obj_id_MaxWheel = byPassData.obj_id_MaxWheel?byPassData.obj_id_MaxWheel:null;
                    if(obj_id_MaxWheel){
                        sendData.append('obj_id', byPassData.obj_id_MaxWheel);
                    }else{
                        sendData.append('obj_id', 'NEW');
                        sendData.append('new_name', 'ล้อแม็ก');
                    }
                    saveImageAPI(sendData);
                }else{ console.log("maxWheel tab3 is url"); }
            }
        }
        if(dataStep3?.capturedImages){  // add on tab 3
            // console.log("dataStep3?.capturedImages", dataStep3?.capturedImages);
                    // capturedImages: data.capturedImages,
                    // capturedTextImages: data.capturedTextImages,
            dataStep3?.capturedImages.forEach((value, index) => {
                // console.log(`capturedImages3[${index}]`, value);
                var url = value;
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', value);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "ACCESSORY");
                    sendData.append('name', "ACCESSORY");
                    sendData.append('obj_id', 'NEW');
                    sendData.append('new_name', dataStep3?.capturedTextImages[index]);
                    saveImageAPI(sendData);
                    // console.log("sendData", value, caseID, dataStep3?.capturedTextImages[index]);
                }else{ console.log("add on tab3 index", index, " is url"); }
            });
        }else{
            console.log("else add on tab 3");
        }

        // ////// document ////// carbook
        if(dataStep4){
            if(dataStep4.imagesCarBook){
                var url = dataStep4.imagesCarBook[0];
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', [dataStep4.imagesCarBook[0]]);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "DOCUMENT");
                    sendData.append('name', "DOCUMENT");
                    // sendData.append('obj_id', byPassData.obj_id_CarBook);
                    let obj_id_CarBook = byPassData.obj_id_CarBook?byPassData.obj_id_CarBook:null;
                    if(obj_id_CarBook){
                        sendData.append('obj_id', byPassData.obj_id_CarBook);
                    }else{
                        sendData.append('obj_id', 'NEW');
                        sendData.append('new_name', 'เล่มทะเบียนรถ');
                    }
                    saveImageAPI(sendData);
                }else{ console.log("carBook tab4 is url"); }
            }
            if(dataStep4.imagesCarTax){
                var url = dataStep4.imagesCarTax[0];
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', [dataStep4.imagesCarTax[0]]);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "DOCUMENT");
                    sendData.append('name', "DOCUMENT");
                    // sendData.append('obj_id', byPassData.obj_id_CarTax);
                    let obj_id_CarTax = byPassData.obj_id_CarTax?byPassData.obj_id_CarTax:null;
                    if(obj_id_CarTax){
                        sendData.append('obj_id', byPassData.obj_id_CarTax);
                    }else{
                        sendData.append('obj_id', 'NEW');
                        sendData.append('new_name', 'ป้ายภาษีรถยนต์');
                    }
                    saveImageAPI(sendData);
                }else{ console.log("carTax tab4 is url"); }
            }
            if(dataStep4.imagesCarChassis){
                var url = dataStep4.imagesCarChassis[0];
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', [dataStep4.imagesCarChassis[0]]);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "DOCUMENT");
                    sendData.append('name', "DOCUMENT");
                    // sendData.append('obj_id', byPassData.obj_id_CarChassis);
                    let obj_id_CarChassis = byPassData.obj_id_CarChassis?byPassData.obj_id_CarChassis:null;
                    if(obj_id_CarChassis){
                        sendData.append('obj_id', byPassData.obj_id_CarChassis);
                    }else{
                        sendData.append('obj_id', 'NEW');
                        sendData.append('new_name', 'เลขตัวถัง');
                    }
                    saveImageAPI(sendData);
                }else{ console.log("carChassis tab4 is url"); }
            }
            if(dataStep4.imagesCarLicense){
                var url = dataStep4.imagesCarLicense[0];
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', [dataStep4.imagesCarLicense[0]]);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "DOCUMENT");
                    sendData.append('name', "DOCUMENT");
                    // sendData.append('obj_id', byPassData.obj_id_CarLicense);
                    let obj_id_CarLicense = byPassData.obj_id_CarLicense?byPassData.obj_id_CarLicense:null;
                    if(obj_id_CarLicense){
                        sendData.append('obj_id', byPassData.obj_id_CarLicense);
                    }else{
                        sendData.append('obj_id', 'NEW');
                        sendData.append('new_name', 'ใบอนุญาติขับขี่ / บัตรประชาชน');
                    }
                    saveImageAPI(sendData);
                }else{ console.log("carLicense tab4 is url"); }
            }
        }
        if(dataStep4?.capturedImages){  // add on tab 4
            // console.log("dataStep4?.capturedImages", dataStep4?.capturedImages);
                    // capturedImages: data.capturedImages,
                    // capturedTextImages: data.capturedTextImages,
            dataStep4?.capturedImages.forEach((value, index) => {
                // console.log(`capturedImages4[${index}]`, value);
                var url = value;
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', value);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "DOCUMENT");
                    sendData.append('name', "DOCUMENT");
                    sendData.append('obj_id', 'NEW');
                    sendData.append('new_name', dataStep4?.capturedTextImages[index]);
                    saveImageAPI(sendData);
                    // console.log("sendData", value, caseID, dataStep3?.capturedTextImages[index]);
                }else{ console.log("add on tab4 index", index, " is url"); }
            });
        }else{
            console.log("else add on tab 4");
        }

        ////// add on ////// tab 5
        //
        if(dataStep5?.capturedImages){  // add on tab 4
            // console.log("dataStep5?.capturedImages", dataStep5?.capturedImages);
                    // capturedImages: data.capturedImages,
            dataStep5?.capturedImages.forEach((value, index) => {
                // console.log(`capturedImages4[${index}]`, value);
                var url = value;
                // console.log(isValidUrl(url));
                if(!isValidUrl(url)){
                    sendData = new FormData();
                    sendData.append('image', value);
                    sendData.append('caseID', caseID);
                    sendData.append('img_type', "OTHER");
                    sendData.append('name', "OTHER");
                    saveImageAPI(sendData);
                    // console.log("sendData", value, caseID, dataStep3?.capturedTextImages[index]);
                }else{ console.log("add on tab5 index", index, " is url"); }
            });
        }else{
            console.log("else add on tab 5");
        }
        //

    };

    //// call API to save image ////
    const saveImageAPI = (sendData, activeStep = null, s_Index = null) => {
        console.log("call saveImageAPI", activeStep, s_Index);
        //     // 'caseID' => 'required',
        //     // 'image' => 'required',
        //     // 'img_type' => 'required',

        if(activeStep){
            // console.log("chk if");
            if(activeStep == 2){
                console.log("chk if 2", s_Index);
                // if(s_Index){
                    // console.log("loop dataStep2");
                    if(dataStep2.capturedImages && dataStep2.capturedImages != "undefined"){
                        dataStep2.capturedImages.forEach((value, index) => {
                            // console.log(`capturedImages2[${index}] = response.data`);
                            if(s_Index == index){
                                console.log("update state", `capturedImages2[${index}]`);
                            }
                        });
                    }
                // }
            }else if(activeStep == 3){
                console.log("chk if 3", s_Index);
                if(s_Index == "SpareTire"){
                    console.log("update SpareTire");
                }else if(s_Index == "CarCAM"){
                    console.log("update CarCAM");
                }
            }else if(activeStep == 4){
                console.log("chk if 4", s_Index);
                if(s_Index == "CarBook"){
                    console.log("update CarBook");
                }else if(s_Index == "CarChassis"){
                    console.log("update CarChassis");
                }
            }
        }

        setLoading(true);
        SaveImage(sendData).then(response => {
            console.log("response from saveImageAPI", response);
            setLoading(false);
            if (response && response.status === 200) {
                // setLoading(false);
                ////// update url to current data (prevent upload image multiple time) //////
                let data = response.data;
                let img_type = data.img_type;
                let new_name = data.new_name;
                console.log("data",data,"type",img_type,"name",new_name);
                if(data && img_type == "ACCESSORY"){
                    if(new_name == "ยางอะไหล่"){
                        console.log("update ยางอะไหล่", dataStep3);
                        setDataStep3((prev) => {
                            // console.log("prev",prev);
                            // let prevData = [...prev];
                            // console.log("prevData",prevData);
                            prev.imagesSpareTire = data.url;
                            prev.obj_id_SpareTire = data.obj_id;
                            // console.log("prev 2",prev);
                            return prev;
                        });
                    }else if(new_name == "กล้องหน้ารถยนต์"){
                        console.log("update กล้องหน้ารถยนต์", dataStep3);
                        setDataStep3((prev) => {
                            prev.imagesCarCAM = data.url;
                            prev.obj_id_CarCAM = data.obj_id;
                            return prev;
                        });
                    }else{
                        console.log("update add on tab3", dataStep3);
                        dataStep3?.capturedImages.forEach((value, index) => {
                            // console.log("capturedTextImages", index, dataStep3?.capturedTextImages[index]);
                            // console.log("data.new_name", data.new_name);
                            if(dataStep3?.capturedTextImages[index] == data.new_name){
                                console.log("== at index",index, "set url to", data.url);
                                let url = data.url;
                                let dataUpdated = "";
                                if (Array.isArray(url)) {
                                    console.log("ARRAY");
                                    dataUpdated = data.url[0];
                                }
                                if (typeof url === 'string') {
                                    try {
                                      new URL(url); // ถ้าไม่ใช่ URL ที่ถูกต้อง บรรทัดนี้จะ error
                                      console.log('URL');
                                      dataUpdated = data.url;
                                    } catch (_) {
                                      console.log('STRING'); // เป็น String ธรรมดาที่ไม่ใช่ URL
                                    }
                                }
                                setDataStep3((prev) => {
                                    prev.capturedImages[index] = dataUpdated;
                                    return prev;
                                });
                            }
                        });
                    }
                }
                if(data && img_type == "DOCUMENT"){
                    if(new_name == "เล่มทะเบียนรถ"){
                        console.log("update เล่มทะเบียนรถ", dataStep4);
                        setDataStep4((prev) => {
                            prev.imagesCarBook = data.url;
                            prev.obj_id_CarBook = data.obj_id;
                            return prev;
                        });
                    }else if(new_name == "เลขตัวถัง"){
                        console.log("update เลขตัวถัง", dataStep4);
                        setDataStep4((prev) => {
                            prev.imagesCarChassis = data.url;
                            prev.obj_id_CarChassis = data.obj_id;
                            return prev;
                        });
                    }else{
                        console.log("update add on tab4", dataStep4);
                        dataStep4?.capturedImages.forEach((value, index) => {
                            console.log("capturedTextImages", index, dataStep4?.capturedTextImages[index]);
                            console.log("data.new_name", data.new_name);
                            if(dataStep4?.capturedTextImages[index] == data.new_name){
                                console.log("== at index",index, "set url to", data.url);
                                let url = data.url;
                                let dataUpdated = "";
                                if (Array.isArray(url)) {
                                    console.log("ARRAY");
                                    dataUpdated = data.url[0];
                                }
                                if (typeof url === 'string') {
                                    try {
                                      new URL(url); // ถ้าไม่ใช่ URL ที่ถูกต้อง บรรทัดนี้จะ error
                                      console.log('URL');
                                      dataUpdated = data.url;
                                    } catch (_) {
                                      console.log('STRING'); // เป็น String ธรรมดาที่ไม่ใช่ URL
                                    }
                                }
                                setDataStep4((prev) => {
                                    prev.capturedImages[index] = dataUpdated;
                                    return prev;
                                });
                            }
                        });
                    }
                }
                ////// end update url to current state //////
            }else if (response && response.data){
                ////// do something alert ? //////
                console.log("API response error ["+ response.status + "]", response.data.message);
            }else{
                console.log("API response error", response);
            }
        })
        // setLoading(false);
    };

    // //// call API to save image (path AddOn only) ////
    // const saveImageAPIAddOn = (activeStep = null, data) => {
    //     console.log("call saveImageAPIAddOn", activeStep, data);
    //     //     // 'caseID' => 'required',
    //     //     // 'image' => 'required',
    //     //     // 'img_type' => 'required',

    //     var sendData = new FormData();

    //     if(activeStep == 3){
    //         console.log("step3", data);
    //         console.log("capturedImages", data?.capturedImages);
    //         console.log("capturedTextImages", data?.capturedTextImages);
    //         console.log("capturedObjIDImages", data?.capturedObjIDImages);

    //             sendData.append('caseID', caseID);
    //             sendData.append('img_type', "ACCESSORY");
    //             // sendData.append('images', data.capturedImages);
    //             // sendData.append('text', data.capturedTextImages);

    //         data?.capturedImages.forEach((value, index) => {
    //             // console.log(`capturedImages3[${index}]`, value);
    //             sendData.append(`image[${index}]`, data.capturedImages[index]);
    //             sendData.append(`text[${index}]`, data.capturedTextImages[index]);
    //             sendData.append(`obj_id[${index}]`, data.capturedObjIDImages[index]);
    //         });

    //     }else if(activeStep == 4){
    //         console.log("step4", data);
    //     }


    //     // setLoading(true);
    //     SaveImageAddOn(sendData).then(response => {
    //         console.log("response from SaveImageAddOn", response);
    //     //     setLoading(false);
    //         if (response && response.status === 200) {
    //     //         // setLoading(false);
    //     //         ////// update url to current state (prevent upload image multiple time) //////
    //     //         let data = response.data;
    //     //         let img_type = data.img_type;
    //     //         let new_name = data.new_name;
    //     //         console.log("data",data,"type",img_type,"name",new_name);
    //     //         if(data && img_type == "ACCESSORY"){
    //     //             if(new_name == "ยางอะไหล่"){
    //     //                 console.log("update ยางอะไหล่", dataStep3);
    //     //                 setDataStep3((prev) => {
    //     //                     // console.log("prev",prev);
    //     //                     // let prevData = [...prev];
    //     //                     // console.log("prevData",prevData);
    //     //                     prev.imagesSpareTire = data.url;
    //     //                     // console.log("prev 2",prev);
    //     //                     return prev;
    //     //                 });
    //     //             }else if(new_name == "กล้องหน้ารถ"){
    //     //                 console.log("update กล้องหน้ารถยนต์", dataStep3);
    //     //                 setDataStep3((prev) => {
    //     //                     prev.imagesCarCAM = data.url;
    //     //                     return prev;
    //     //                 });
    //     //             }else{
    //     //                 console.log("update add on tab3", dataStep3);
    //     //                 dataStep3?.capturedImages.forEach((value, index) => {
    //     //                     // console.log("capturedTextImages", index, dataStep3?.capturedTextImages[index]);
    //     //                     // console.log("data.new_name", data.new_name);
    //     //                     if(dataStep3?.capturedTextImages[index] == data.new_name){
    //     //                         // console.log("== at index",index, "set url to", data.url);
    //     //                         setDataStep3((prev) => {
    //     //                             prev.capturedImages[index] = data.url;
    //     //                             return prev;
    //     //                         });
    //     //                     }
    //     //                 });
    //     //             }
    //     //         }
    //     //         if(data && img_type == "DOCUMENT"){
    //     //             if(new_name == "เล่มทะเบียนรถ"){
    //     //                 console.log("update เล่มทะเบียนรถ", dataStep4);
    //     //                 setDataStep4((prev) => {
    //     //                     prev.imagesCarBook = data.url;
    //     //                     return prev;
    //     //                 });
    //     //             }else if(new_name == "เลขตัวถัง"){
    //     //                 console.log("update เลขตัวถัง", dataStep4);
    //     //                 setDataStep4((prev) => {
    //     //                     prev.imagesCarChassis = data.url;
    //     //                     return prev;
    //     //                 });
    //     //             }else{
    //     //                 console.log("update add on tab4", dataStep4);
    //     //                 dataStep4?.capturedImages.forEach((value, index) => {
    //     //                     console.log("capturedTextImages", index, dataStep4?.capturedTextImages[index]);
    //     //                     console.log("data.new_name", data.new_name);
    //     //                     if(dataStep4?.capturedTextImages[index] == data.new_name){
    //     //                         console.log("== at index",index, "set url to", data.url);
    //     //                         setDataStep4((prev) => {
    //     //                             prev.capturedImages[index] = data.url;
    //     //                             return prev;
    //     //                         });
    //     //                     }
    //     //                 });
    //     //             }
    //     //         }
    //     //         ////// end update url to current state //////
    //         }else if (response && response.data){
    //             ////// do something alert ? //////
    //             console.log("API response error ["+ response.status + "]", response.data.message);
    //         }else{
    //             console.log("API response error", response);
    //         }
    //     })
        
    // };

    //// call API to save image + update response back to dataStep ////
    const saveImageAPIAndUpdate = (sendData, activeStep = null, onSubmitData) => {
        console.log("call saveImageAPIAndUpdate", activeStep);
        //     // 'caseID' => 'required',
        //     // 'image' => 'required',
        //     // 'img_type' => 'required',

        setLoading(true);
        SaveImage(sendData).then(response => {
            console.log("response from saveImageAPI", response);
            setLoading(false);
            if (response && response.status === 200) {
                // setLoading(false);
                ////// update url to current state (prevent upload image multiple time) //////
                let responseData = response.data;
                let img_type = responseData.img_type;
                let new_name = responseData.new_name;
                                let url = responseData.url;
                                let dataUpdated = "";
                                if (Array.isArray(url)) {
                                    console.log("ARRAY");
                                    dataUpdated = responseData.url[0];
                                }
                                if (typeof url === 'string') {
                                    try {
                                      new URL(url); // ถ้าไม่ใช่ URL ที่ถูกต้อง บรรทัดนี้จะ error
                                      console.log('URL');
                                      dataUpdated = responseData.url;
                                    } catch (_) {
                                      console.log('STRING'); // เป็น String ธรรมดาที่ไม่ใช่ URL
                                    }
                                }
                console.log("responseData",responseData,"type",img_type,"name",new_name);
                if(responseData && img_type == "ACCESSORY"){
                    if(new_name == "ยางอะไหล่"){
                        console.log("update ยางอะไหล่", onSubmitData);
                        // setDataStep3((prev) => {
                        //     // console.log("prev",prev);
                        //     // let prevData = [...prev];
                        //     // console.log("prevData",prevData);
                        //     prev.imagesSpareTire = responseData.url;
                        //     // console.log("prev 2",prev);
                        //     return prev;
                        // });
                        onSubmitData.imagesSpareTire[0] = dataUpdated;
                    }else if(new_name == "กล้องหน้ารถยนต์"){
                        console.log("update กล้องหน้ารถยนต์", onSubmitData);
                        // setDataStep3((prev) => {
                        //     prev.imagesCarCAM = responseData.url;
                        //     return prev;
                        // });
                        onSubmitData.imagesCarCAM[0] = dataUpdated;
                    }else{
                        console.log("update add on tab3", dataStep3);
                        console.log("onSubmitData tab3", onSubmitData);
                        onSubmitData?.capturedImages.forEach((value, index) => {
                            // console.log("capturedTextImages", index, onSubmitData?.capturedTextImages[index]);
                            // console.log("data.new_name", data.new_name);
                            if(onSubmitData?.capturedTextImages[index] == responseData.new_name){
                                console.log("== at index",index, "set url to", responseData.url);
                                // let url = responseData.url;
                                // let dataUpdated = "";
                                // if (Array.isArray(url)) {
                                //     console.log("ARRAY");
                                //     dataUpdated = responseData.url[0];
                                // }
                                // if (typeof url === 'string') {
                                //     try {
                                //       new URL(url); // ถ้าไม่ใช่ URL ที่ถูกต้อง บรรทัดนี้จะ error
                                //       console.log('URL');
                                //       dataUpdated = responseData.url;
                                //     } catch (_) {
                                //       console.log('STRING'); // เป็น String ธรรมดาที่ไม่ใช่ URL
                                //     }
                                // }
                                // setDataStep3((prev) => {
                                //     prev.capturedImages[index] = dataUpdated;
                                //     return prev;
                                // });
                                onSubmitData.capturedImages[index] = dataUpdated;
                            }
                        });
                    }
                }
                if(responseData && img_type == "DOCUMENT"){
                    if(new_name == "เล่มทะเบียนรถ"){
                        console.log("update เล่มทะเบียนรถ", onSubmitData);
                        // setDataStep4((prev) => {
                        //     prev.imagesCarBook = responseData.url;
                        //     return prev;
                        // });
                        onSubmitData.imagesCarBook[0] = dataUpdated;
                    }else if(new_name == "เลขตัวถัง"){
                        console.log("update เลขตัวถัง", onSubmitData);
                        // setDataStep4((prev) => {
                        //     prev.imagesCarChassis = responseData.url;
                        //     return prev;
                        // });
                        onSubmitData.imagesCarChassis[0] = dataUpdated;
                    }else{
                        console.log("update add on tab4", dataStep4);
                        console.log("onSubmitData tab4", onSubmitData);
                        onSubmitData?.capturedImages.forEach((value, index) => {
                            console.log("capturedTextImages", index, onSubmitData?.capturedTextImages[index]);
                            console.log("responseData.new_name", responseData.new_name);
                            if(onSubmitData?.capturedTextImages[index] == responseData.new_name){
                                console.log("== at index",index, "set url to", responseData.url);
                                // setDataStep4((prev) => {
                                //     prev.capturedImages[index] = responseData.url;
                                //     return prev;
                                // });
                                onSubmitData.capturedImages[index] = dataUpdated;
                            }
                        });
                    }
                }
                ////// end update url to current state //////
            }else if (response && response.data){
                ////// do something alert ? //////
                console.log("API response error ["+ response.status + "]", response.data.message);
            }else{
                console.log("API response error", response);
            }
        })
        // setLoading(false);
    };



  return (
    <div className="d-flex flex-column align-items-center pt-3 container">
      {/*<h3>Self Inspection</h3>*/}

        {
            loading ? <CircularProgress size={loadingSize} />
            : completed? <CompletedComponent />
            : <>
            <h3>ตรวจสภาพรถด้วยตนเอง</h3>
            <Stepper
                activeStep={activeStep - 1}
                // sx={{ pt: 3, pb: 5 }}
                orientation="vertical"
            >
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                        <StepContent>
                          {
                            getStepContent(activeStep)
                          }
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            </>
        }
      
        <div id="footer" style={{width:"100%",height:"20px"}}></div>
    </div>
  );
}

export default RegisterComponent;
